import './chosen.directive.ajscss';

import { ISearchService } from '@agent/core/search/search.service';
import { isArray, isDefined } from 'angular';
import i18next from 'i18next';

import { Option } from '@contact/upgrade';

import templateUrl from './chosen.directive.ajs.html';

export let ChosenDirectiveAjs = (search: ISearchService) => ({
  restrict: 'E',
  require: 'ngModel',
  scope: {
    ngModel: '=',
    collection: '=',
    htmlid: '@',
    multiple: '=?',
    placeholder: '@?',
    callback: '&callback',
    keypressCallback: '&keypressCallback',
    keyupCallback: '&keyupCallback',
    disabled: '<',
  },
  templateUrl,
  link: (scope, element, attrs, chosenCtrl) => {
    scope.multiple = scope.multiple || isArray(scope.ngModel);
    scope.placeholder = isDefined(attrs.placeholder)
      ? attrs.placeholder
      : (attrs.placeholder = scope.multiple ? 'commons:basic.chosendefaultplaceholder' : 'commons:basic.chosensingledefaultplaceholder');
    scope.originalPlaceholder = scope.placeholder;
    scope.disabled = scope.$eval(attrs.disabled) || false;
    scope.resultExpanded = false;
    scope.filter = '';
    scope.idHTML = attrs.htmlid;
    scope.currentIndex = 0;
    scope.currentElem = null;

    if (scope.ngModel == null) {
      scope.ngModel = {};
    }
    scope.init = () => {
      let initialValue = scope.ngModel;
      let collection = scope.collection || [];
      if (scope.multiple) {
        scope.ngModel = [];
        for (let i = 0; i < initialValue.length; i++) {
          for (let y = 0; y < collection.length; y++) {
            if (initialValue[i].name === scope.collection[y].name) {
              scope.collection[y].chosen = true;
              scope.ngModel.push(scope.collection[y]);
            }
          }
        }
      } else {
        scope.ngModel = {};
        for (let y = 0; y < collection.length; y++) {
          if (initialValue.name === scope.collection[y].name) {
            scope.ngModel = scope.collection[y];
          }
        }
      }
      scope.filterCollection();
    };

    scope.$watch('collection', data => {
      scope.collection = data || [];
      scope.filterCollection();
    });
    scope.$watch('ngModel', newvalue => {
      if (newvalue == null || newvalue === {}) {
        scope.resetAll();
        scope.placeholder = scope.originalPlaceholder;
        scope.filter = '';
      } else {
        scope.ngModel = newvalue;
        scope.filter = newvalue.name;
      }
      if (scope.multiple && newvalue.length > 0) {
        scope.placeholder = '';
      }
    });

    element.on('keydown', e => {
      let caseUp = false;
      let key = e.keyCode;
      switch (key) {
        case 38: // UP
          caseUp = true;
        case 40: // DOWN
          if (!scope.resultExpanded) {
            scope.resultExpanded = true;
          }
          let collectionDisplayed: any[] = [];
          for (let x = 0; x < scope.collection.length; x++) {
            // LIST THE displayed collection
            if (scope.collection[x].displayed) {
              collectionDisplayed.push(x);
            }
          }

          let firstIndex = collectionDisplayed[0];
          let lastIndex = collectionDisplayed[collectionDisplayed.length - 1];

          for (let d = 0; d < collectionDisplayed.length; d++) {
            let realIndex = collectionDisplayed[d];
            if ((!caseUp && scope.currentIndex <= realIndex) || (caseUp && scope.currentIndex >= realIndex)) {
              if (scope.collection[realIndex].selected) {
                scope.collection[realIndex].selected = false;
                scope.currentIndex = null;
                let selectedIndex = realIndex;
                if (caseUp) {
                  if (d - 1 < 0) {
                    // If element unselected is the first
                    selectedIndex = lastIndex; // The last
                  } else {
                    selectedIndex = collectionDisplayed[d - 1]; // The Previous
                  }
                } else if (!caseUp) {
                  if (d + 1 >= collectionDisplayed.length) {
                    // If element unselected is the last
                    selectedIndex = firstIndex; // The First
                  } else {
                    selectedIndex = collectionDisplayed[d + 1]; // The Next
                  }
                }
                scope.collection[selectedIndex].selected = true;
                scope.currentIndex = selectedIndex;
                scope.currentElem = scope.collection[selectedIndex];

                // scroll for element go into view
                let elem = document.getElementById(scope.idHTML + '_' + selectedIndex);
                if (elem) {
                  elem.scrollIntoView();
                }
                break; // Aaaaand break !
              }
            }
          }
          scope.$apply();
          break;
        case 13: // ENTER
          if (scope.resultExpanded) {
            e.preventDefault();
            e.stopPropagation();
            if (scope.currentElem !== null && !scope.currentElem.chosen) {
              scope.selectElem(scope.currentElem);
              scope.$apply();
            }
          } else {
            scope.resultExpanded = true;
          }
          break;
        case 9: // TABULATION
          scope.unfocusResult();
          break;
        case 8: // BACKSPACE
          if (!scope.resultExpanded) {
            scope.resultExpanded = true;
          }
          if (scope.multiple && scope.ngModel.length !== undefined && scope.filter === '' && scope.ngModel.length !== 0) {
            let elemToPop = scope.ngModel.pop();
            if (elemToPop) {
              elemToPop.chosen = false;
            }
          }
          if (!scope.multiple && scope.ngModel !== '') {
            scope.removeElem(scope.ngModel);
          }
          if (scope.ngModel.length === 0) {
            scope.placeholder = scope.originalPlaceholder;
          }
          scope.$apply();
          break;
        case 27: // ESCAPE
          scope.resultExpanded = false;
          scope.$apply();
          break;
        default:
          if (scope.keypressCallback) {
            scope.keypressCallback();
          }
          break;
      }
    });
    element.on('keyup', () => {
      scope.keyupCallback();
    });
    scope.processFilterCollection = () => {
      scope.resultExpanded = true;
      scope.filterCollection();
    };
    scope.filterCollection = () => {
      let first = true;
      let collection = scope.collection || [];
      for (let x = 0; x < collection.length; x++) {
        if (scope.collection[x].name !== undefined) {
          // remove accented characters from search and compare with normalized collection item too
          const collectionItemNormalized = search.normalize(scope.collection[x].name);
          const scopeFilterNormalized = search.normalize(Option.of(scope.filter).getOrElse(''));
          if (collectionItemNormalized.indexOf(scopeFilterNormalized) >= 0) {
            scope.collection[x].selected = false;
            if (first && !scope.collection[x].chosen) {
              first = false;
              scope.collection[x].selected = true;
              scope.currentIndex = x;
              scope.currentElem = scope.collection[x];
            }
            scope.collection[x].displayed = true;
          } else {
            scope.collection[x].displayed = false;
          }
        }
      }
    };
    scope.resetAll = () => {
      let collection = scope.collection || [];
      for (let x = 0; x < collection.length; x++) {
        scope.collection[x].selected = false;
        scope.collection[x].chosen = false;
        scope.collection[x].displayed = true;
      }
    };
    scope.empty = () => (scope.ngModel ? scope.ngModel.name === undefined : true);
    scope.resetInputText = () => {
      let elem = document.getElementById(scope.idHTML);
      if (elem && (elem as HTMLInputElement).value !== '') {
        (elem as HTMLInputElement).value = '';
      }
    };
    scope.selectElem = (currentElem, e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (currentElem === null) {
        // EXPERIMENTAL NG-CHANGE REACT
        chosenCtrl.$setViewValue(currentElem);
        scope.viewValue = currentElem;
        scope.callback();
      } else if (!currentElem.chosen) {
        if (scope.multiple && (scope.ngModel.length === 0 || scope.ngModel.indexOf(currentElem) < 0)) {
          scope.ngModel.push(currentElem);
          scope.filter = '';
          scope.filterCollection();
          scope.callback();
        } else {
          if (scope.ngModel) {
            scope.removeElem(scope.ngModel, undefined, true);
          }
          scope.ngModel = currentElem;
          scope.resultExpanded = false;

          // EXPERIMENTAL NG-CHANGE REACT
          chosenCtrl.$setViewValue(currentElem);
          scope.viewValue = currentElem;
          scope.filter = e ? '' : currentElem.name;
          scope.callback();
        }
        currentElem.chosen = true;
        scope.placeholder = '';
      } else {
        scope.removeElem(currentElem);
      }
    };
    scope.unfocusResult = () => {
      scope.resultExpanded = false;
    };
    scope.focusResult = () => {
      element.find('input')[0].focus();
      scope.resultExpanded = true;
    };
    scope.getPlaceHolder = () => {
      if (scope.multiple && (!isDefined(scope.ngModel) || scope.ngModel.length === 0)) {
        return i18next.t(scope.originalPlaceholder);
      } else if (
        !scope.multiple &&
        (scope.ngModel == null || (Object.keys(scope.ngModel).length === 0 && scope.ngModel.constructor === Object))
      ) {
        return i18next.t(scope.originalPlaceholder);
      } else if (!scope.multiple && !!scope.ngModel) {
        return scope.ngModel.name;
      }
      return '';
    };
    scope.removeElemSingle = (elem, e) => {
      scope.filter = '';
      scope.removeElem(elem, e);
      scope.focusResult();
    };
    scope.removeElem = (elem, e, dontCallBack = false) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      elem.chosen = false;
      if (scope.multiple) {
        scope.ngModel.splice(scope.ngModel.indexOf(elem), 1);
      } else {
        scope.ngModel = {};
        scope.placeholder = scope.originalPlaceholder;
      }
      if (scope.ngModel.length === 0) {
        scope.placeholder = scope.originalPlaceholder;
      }
      // EXPERIMENTAL NG-CHANGE REACT
      chosenCtrl.$setViewValue(scope.ngModel);
      scope.viewValue = scope.ngModel;
      if (!dontCallBack) {
        scope.callback();
      }
      // EXPERIMENTAL NG-CHANGE
    };
    scope.init();
    scope.callback();
    scope.keypressCallback();

    // fix to prevent memory leak
    scope.$on('$destroy', () => {
      // remove listener
      element.off('keydown');
      element.off('keyup');
    });
    element.on('$destroy', () => {
      scope.$destroy();
    });
  },
});

export default 'cngChosen';
